export enum ConfirmationWayEnum {
    Sms = 1,
    Call = 2,
    Email = 3,
    Push = 4,
    Manual = 5,
    CallBack = 6,
}
